import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FlatTemplate } from '../../models/FlatTemplate';

@Injectable()
export class TemplateProvider {

  ready = false;

  templateFetched = new Subject<void>();

  currentTemplate = new FlatTemplate();

  hasKPIs: boolean;
  hasOP: boolean;

  merge(template: FlatTemplate) {
    this.currentTemplate.Notifications =  this.currentTemplate.Notifications ? template.Notifications : false;
    this.currentTemplate.LogBook = this.currentTemplate.LogBook ? template.LogBook : false;
    this.currentTemplate.Reports = this.currentTemplate.Reports ? template.Reports : false;
    this.currentTemplate.Outages = this.currentTemplate.Outages ? template.Outages : false;
    this.currentTemplate.Customer.SitesList = this.currentTemplate.Customer.SitesList ? template.Customer.SitesList : false;
    this.currentTemplate.Customer.KPI = {
      Availability: this.currentTemplate.Customer.KPI.Availability ? template.Customer.KPI.Availability : false,
      Reliability: this.currentTemplate.Customer.KPI.Reliability ? template.Customer.KPI.Reliability : false,
      ServiceHours: this.currentTemplate.Customer.KPI.ServiceHours ? template.Customer.KPI.ServiceHours : false
    };
    this.currentTemplate.Site.TrainsList = this.currentTemplate.Site.TrainsList ? template.Site.TrainsList : false;
    this.currentTemplate.Site.KPI = {
      Availability: this.currentTemplate.Site.KPI.Availability ? template.Site.KPI.Availability : false,
      Reliability: this.currentTemplate.Site.KPI.Reliability ? template.Site.KPI.Reliability : false,
      ServiceHours: this.currentTemplate.Site.KPI.ServiceHours ? template.Site.KPI.ServiceHours : false
    };
    this.currentTemplate.Train.EquipmentTrain = this.currentTemplate.Train.EquipmentTrain ? template.Train.EquipmentTrain : false;
    this.currentTemplate.Train.OperationalProfile = this.currentTemplate.Train.OperationalProfile ? template.Train.OperationalProfile: false;
    this.currentTemplate.Train.KPI = {
      Availability: this.currentTemplate.Train.KPI.Availability ? template.Train.KPI.Availability : false,
      Reliability: this.currentTemplate.Train.KPI.Reliability ? template.Train.KPI.Reliability : false,
      ServiceHours: this.currentTemplate.Train.KPI.ServiceHours ? template.Train.KPI.ServiceHours : false,
      Alarms: this.currentTemplate.Train.KPI.Alarms ? template.Train.KPI.Alarms : false,
      Trips: this.currentTemplate.Train.KPI.Trips ? template.Train.KPI.Trips : false,
      SuccessfulStarts: this.currentTemplate.Train.KPI.SuccessfulStarts ? template.Train.KPI.SuccessfulStarts : false,
      PowerGenerated: false,
      AveragePower: false
    };
    this.currentTemplate.tags.push(...template.tags);

    this.hasKPI();
    this.hasOperationalProfile();

  }

  hasKPI() {
    if (!this.currentTemplate.Train.KPI.Availability || !this.currentTemplate.Train.KPI.Reliability || !this.currentTemplate.Train.KPI.ServiceHours || !this.currentTemplate.Train.KPI.Alarms|| !this.currentTemplate.Train.KPI.Trips|| !this.currentTemplate.Train.KPI.SuccessfulStarts) {
      this.hasKPIs = false;
      return;
    }
    this.hasKPIs = true;
  }

  hasOperationalProfile() {
    if (!this.currentTemplate.Train.OperationalProfile) {
      this.hasOP = false;
      return;
    }
    this.hasOP = true;
  }

}



// WEBPACK FOOTER //
// ./src/providers/template/template.ts